import { Button } from "@mychili/clarity-ui";
import { useTranslation } from "react-i18next";
import logoIconImage from "../assets/logo-icon.svg";
import fakedoorImage from "../assets/wait-icon.png";

type FakedoorMobileProps = {
  link: string;
};

export const FakedoorMobile = ({ link }: FakedoorMobileProps) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (link) window.location.href = link;
  };

  return (
    <div className="flex h-full w-full flex-col">
      <div className="mt-auto mb-4 flex flex-col items-center gap-2">
        {" "}
        <img className="block w-[100px]" src={fakedoorImage} alt="logo" />
        <p className="typography-big-text-semibold px-10 text-center">
          {t("fakedoor.title")}
        </p>
        <p className="typography-regular-text-regular mx-10 text-center">
          {t("fakedoor.mobile.subtitle")}
        </p>
      </div>
      <div className="mt-auto flex w-full flex-col gap-3 bg-background-neutral p-5">
        <Button
          variant="primary"
          className="mt-auto w-full"
          onClick={handleClick}
        >
          <img src={logoIconImage} alt="logo_icon" />
          {t("payment.app_button_text")}
        </Button>
      </div>
    </div>
  );
};
